<template>
    <div v-if="modal.backdrop">
        <div 
            class="modal fade"
            :class="modal.isOpen ? 'show' : ''"
            tabindex="-1"
            style="display: block"
            role="dialog"
            aria-hidden="true"
            @click="modal.dismiss ? $event.target.classList.contains('modal') ? close() : true : true"
        >
            <div class="modal-dialog modal-md modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Filter Export MARS</h5>
                        <button type="button" class="close" @click="close" v-html="ic('close')"/>
                    </div>
                    <div class="modal-body pt-3">
                        <div class="row">
                            <div class="form-group col-md-12">
                                <label for="companyId" class="form-label">Perusahaan</label>
                                <selectize
                                    id="companyId"
                                    v-model="filters.id_company"
                                    data-placeholder="Pilih Perusahaan"
                                    @input="getListDepo({id_perusahaan: filters.id_company})" 
                                    required
                                >
                                    <option :value="perusahaan.id"  v-for="(perusahaan, index) in form.companies" :key="index"> {{perusahaan.nama_perusahaan}}</option>
                                </selectize>
                            </div>
                            <div class="form-group col-md-12">
                                <label for="depo" class="form-label">Depo</label>
                                <selectize
                                    id="depo"
                                    v-model="filters.ids_depo"
                                    :settings="selectizeConfig"
                                    data-placeholder="Pilih Depo" required>
                                    <option :value="depo.id"  v-for="(depo, index) in list_depo" :key="index"> {{depo.nama_depo}}</option>
                                </selectize>
                            </div>
                            <div class="form-group col-md-6">
                                <label for="tanggal-mulai" class="form-label">Mulai Tanggal</label>
                                <input id="tanggal-mulai" type="date" class="form-control" required v-model="filters.start_date" :max="filters.end_date">
                            </div>

                            <div class="form-group col-md-6">
                                <label for="tanggal-selesai" class="form-label">Sampai Tanggal</label>
                                <input required id="tanggal-selesai" type="date" class="form-control" v-model="filters.end_date" :max="form.today">
                            </div>
                            <div class="form-group col-md-12">
                                <label for="last-sequence" class="form-label">Antrian Akhir</label>
                                <input required id="last-sequence" type="number" class="form-control" v-model="filters.last_sequence" :min="1">
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-white" @click="close">Tutup</button>
                        <button type="button" class="btn btn-primary" @click="submit">OK</button>
                    </div>
                </div>   
            </div>  
        </div>
    </div>
    
</template>
<script>
import { mapState,mapActions } from "vuex";
import helper from "@/assets/js/helper.js"
export default {
    name: "Modal",
    data(){
        return{
            form:{
                today: new Date().toISOString().split('T')[0],
                companies:[]
            },
            selectizeConfig: {
                maxItems: 99,
                plugins: ["remove_button"]
            },
        }
    },
    mixins: [helper],
    computed: {
        ...mapState("depo",['list_depo']),
        ...mapState("external_mars",{
            modal: state => state.modal,
            filters: state => state.filters.exportMars
        }),
    },
    methods: {
        ...mapActions("depo",['getListDepo']),
        ...mapActions('perusahaan', ['getListPerusahaan']),
        async _getCompanies(){
            try {
                const response = await this.getListPerusahaan()
                this.form.companies = response.data
            } catch (error) {
                this.toast(error)
            }
        },
        submit(){
            this.$emit("submit");
            this.close()
        },
        close(){
            this.$emit("close");
        }
    },  
    mounted() {
        this._getCompanies()
    }
}
</script>


